<template>
  <div class="d-flex flex-row pb-4" style="gap: 15px">
    <div class="card w-50">
      <div
        class="d-flex flex-row align-items-center justify-content-between p-3 pl-4"
      >
        <h3 class="text-center pl-2">Users</h3>
        <i
          class="fa fa-plus text-success pr-4"
          style="cursor: pointer"
          v-if="permissions.find((e) => e.permission_name == 'Create Admin')"
          @click.prevent="OpenAddUser"
        ></i>
      </div>
      <div>
        <div
          class="d-flex flex-column p-3"
          :style="
            !permissions.find((e) => e.permission_name == 'View Admin')
              ? 'filter: blur(4px); pointer-events: none;'
              : ''
          "
          style="
            gap: 10px !important;
            height: 500px !important;
            overflow-y: auto;
          "
        >
          <div
            v-for="(user, index) in users"
            :key="index"
            class="card d-flex flex-row align-items-center justify-content-between p-2 pt-3 px-4 w-100"
          >
            <div class="d-flex flex-column w-50">
              <h4>{{ user.name }}</h4>
              <p>{{ user.email }}</p>
              <div class="d-flex flex-row" style="gap: 10px">
                <button
                  :disabled="
                    !permissions.find(
                      (e) => e.permission_name == 'Update Admin'
                    )
                  "
                  @click.prevent="editUser(user)"
                  class="btn btn-secondary btn-xs"
                  style="width: max-content; margin-top: -10px"
                >
                  <i class="fa fa-pencil mr-1"></i>Edit
                </button>
                <button
                  :disabled="
                    !permissions.find(
                      (e) => e.permission_name == 'Delete Admin'
                    )
                  "
                  @click.prevent="deleteUser(user)"
                  class="btn btn-danger btn-xs"
                  style="width: max-content; margin-top: -10px"
                >
                  <i class="fa fa-trash mr-1"></i>Delete
                </button>
              </div>
            </div>
            <button
              :disabled="
                !permissions.find(
                  (e) => e.permission_name == 'Assign Permissions'
                )
              "
              class="btn btn-outline-success d-flex flex-row align-items-center"
              @click.prevent="addPermissions(user)"
            >
              <i class="fa fa-cog fa-spin fa-fw mr-2"></i> Permissions
            </button>
          </div>
        </div>
        <div
          style="
            position: absolute;
            margin-top: -50%;
            z-index: 1;
            width: max-content;
            left: 25%;
          "
          v-if="!permissions.find((e) => e.permission_name == 'View Admin')"
        >
          <span style="color: red"
            ><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing
            permission.</span
          >
        </div>
      </div>
    </div>
    <div class="card w-50 py-3" v-if="add_user">
      <div
        class="d-flex flex-row align-items-center justify-content-between px-2"
      >
        <h3 class="text-center pl-3">
          {{ edit_id ? "Update" : "Create" }} User
        </h3>
        <i
          class="fa fa-times text-danger mr-2"
          style="cursor: pointer"
          @click.prevent="CloseAddUser"
          ><span class="pl-1">Close</span></i
        >
      </div>
      <div
        class="d-flex flex-column p-3"
        style="height: 500px !important; overflow-y: auto; gap: 10px !important"
      >
        <div class="d-flex flex-row align-items-center">
          <span class="w-25 fw-light font-monospace">Name</span>
          <input
            class="form-control"
            v-model="user_details.name"
            type="text"
            placeholder="Name"
          />
        </div>
        <div class="d-flex flex-row align-items-center">
          <span class="w-25 fw-light font-monospace">Email</span>
          <input
            class="form-control"
            v-model="user_details.email"
            type="text"
            placeholder="Email"
          />
        </div>
        <div class="d-flex flex-row align-items-center">
          <span class="w-25 fw-light font-monospace">Passowrd</span>
          <input
            class="form-control"
            v-model="user_details.password"
            type="text"
            placeholder="Passowrd"
          />
        </div>
        <div class="d-flex flex-row justify-content-center">
          <button class="btn btn-success" @click.prevent="saveAdmin">
            <i class="fa fa-save mr-2"></i>Save User
          </button>
        </div>
      </div>
    </div>
    <div class="card w-50 py-3" v-if="add_permission">
      <div
        class="d-flex flex-row align-items-center justify-content-between px-2"
      >
        <h3 class="text-center pl-3">
          Permissions for {{ add_permissions_for.name }}
        </h3>
        <i
          class="fa fa-times text-danger mr-2"
          style="cursor: pointer"
          @click.prevent="closePermissions"
          ><span class="pl-1">Close</span></i
        >
      </div>
      <div class="d-flex flex-row-reverse pr-3 my-2">
        <button class="btn btn-success" @click.prevent="saveAdminPermission">
          <i class="fa fa-save mr-1"></i>Save
        </button>
      </div>
      <div
        class="d-flex flex-column p-3"
        style="height: 500px !important; overflow-y: auto; gap: 10px !important"
      >
        <div
          v-for="(section, section_index) in sections"
          :key="section_index"
          class="card bg-secondary"
        >
          <div
            class="d-flex flex-row align-items-center justify-content-between p-3"
          >
            <span>{{ section.name }}</span>
            <input
              type="checkbox"
              v-model="section.checked"
              @change="checkMain(section_index)"
            />
          </div>
          <div
            class="card d-flex flex-column m-2 p-3"
            v-if="section.permissions && section.permissions.length"
          >
            <div
              v-for="(permission, permission_index) in section.permissions"
              :key="`S${section_index}P${permission_index}`"
              class="d-flex flex-row align-items-center justify-content-between p-2"
            >
              <span>{{ permission.name }}</span>
              <input
                v-model="permission.checked"
                @change="checkSub(section_index, permission_index)"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      users: [],
      add_user: false,
      edit_id: null,
      user_details: {
        name: null,
        email: null,
        password: null,
      },
      add_permission: false,
      add_permissions_for: null,
      sections: [
        {
          id: 1,
          name: "ADMINS",
          checked: false,
          permissions: [
            {
              name: "View Admin",
              checked: false,
            },
            {
              name: "Create Admin",
              checked: false,
            },
            {
              name: "Delete Admin",
              checked: false,
            },
            {
              name: "Update Admin",
              checked: false,
            },
            {
              name: "Assign Permissions",
              checked: false,
            },
          ],
        },
        {
          id: 2,
          name: "COUPONS",
          checked: false,
          permissions: [
            {
              name: "View Coupons",
              checked: false,
            },
            {
              name: "Create Coupons",
              checked: false,
            },
            {
              name: "Edit Coupons",
              checked: false,
            },
            {
              name: "Delete Coupons",
              checked: false,
            },
          ],
        },
        {
          id: 3,
          name: "BULK UPLOAD",
          checked: false,
          permissions: [
            {
              name: "Upload Data",
              checked: false,
            },
          ],
        },
        {
          id: 4,
          name: "DELIVERY CHARGES",
          checked: false,
          permissions: [
            {
              name: "View Delivery Charge",
              checked: false,
            },
            {
              name: "Update Delivery Charge",
              checked: false,
            },
          ],
        },
        {
          id: 5,
          name: "ORDER",
          checked: false,
          permissions: [
            {
              name: "View Orders",
              checked: false,
            },
            {
              name: "Export Orders",
              checked: false,
            },
            {
              name: "Change Status",
              checked: false,
            },
          ],
        },
        {
          id: 6,
          name: "CATEGORY",
          checked: false,
          permissions: [
            {
              name: "View Categories",
              checked: false,
            },
            {
              name: "Create Category",
              checked: false,
            },
            {
              name: "Edit Category",
              checked: false,
            },
            {
              name: "Active/Inactive Category",
              checked: false,
            },
          ],
        },
        {
          id: 7,
          name: "OPTIONS",
          checked: false,
          permissions: [
            {
              name: "View Options",
              checked: false,
            },
            {
              name: "Create Option",
              checked: false,
            },
            {
              name: "Edit Option",
              checked: false,
            },
            {
              name: "Active/Inactive Option",
              checked: false,
            },
          ],
        },
        {
          id: 8,
          name: "OPTION VALUES",
          checked: false,
          permissions: [
            {
              name: "View Option Values",
              checked: false,
            },
            {
              name: "Create Option Value",
              checked: false,
            },
            {
              name: "Edit Option Value",
              checked: false,
            },
            {
              name: "Active/Inactive Option Value",
              checked: false,
            },
          ],
        },
        {
          id: 9,
          name: "OPTION VALUE TYPES",
          checked: false,
          permissions: [
            {
              name: "View Option Value Types",
              checked: false,
            },
            // {
            //     name: 'Create Option Value Type',
            //     checked: false,
            // }, {
            //     name: 'Edit Option Value Type',
            //     checked: false,
            // }, {
            //     name: 'Active/Inactive Option Value Type',
            //     checked: false,
            // },
          ],
        },
        {
          id: 10,
          name: "QUANTITY",
          checked: false,
          permissions: [
            {
              name: "View Quantity Values",
              checked: false,
            },
            {
              name: "Save Quantity Values",
              checked: false,
            },
          ],
        },
        {
          id: 11,
          name: "CONTACT REQUEST",
          checked: false,
          permissions: [
            {
              name: "View Contact Requests",
              checked: false,
            },
            {
              name: "View Messages",
              checked: false,
            },
            {
              name: "Remove Contact Requests",
              checked: false,
            },
          ],
        },
        {
          id: 12,
          name: "SITE USERS",
          checked: false,
          permissions: [
            {
              name: "View Site Users",
              checked: false,
            },
            {
              name: "Edit Site Users",
              checked: false,
            },
            {
              name: "Remove Site Users",
              checked: false,
            },
            {
              name: "Abandon Cart",
              checked: false,
            },
            {
              name: "Active/Inactive Site Users",
              checked: false,
            },
            {
              name: "Export Site Users",
              checked: false,
            },
          ],
        },
        {
          id: 13,
          name: "TESTIMONIALS",
          checked: false,
          permissions: [
            {
              name: "View Testimonial",
              checked: false,
            },
            {
              name: "Create Testimonial",
              checked: false,
            },
            {
              name: "Edit Testimonial",
              checked: false,
            },
            {
              name: "Remove Testimonial",
              checked: false,
            },
            {
              name: "Active/Inactive Testimonial",
              checked: false,
            },
          ],
        },
        {
          id: 14,
          name: "BLOGS",
          checked: false,
          permissions: [
            {
              name: "View Blogs",
              checked: false,
            },
            {
              name: "Create Blogs",
              checked: false,
            },
            {
              name: "Edit Blogs",
              checked: false,
            },
            {
              name: "Remove Blogs",
              checked: false,
            },
            {
              name: "Active/Inactive Blogs",
              checked: false,
            },
          ],
        },
        {
          id: 15,
          name: "SITE LOGO",
          checked: false,
          permissions: [
            {
              name: "View Site Logo",
              checked: false,
            },
            {
              name: "Update Site Logo",
              checked: false,
            },
            {
              name: "Remove Site Logo",
              checked: false,
            },
          ],
        },
      ],
      permissions: null,
    };
  },
  mounted() {
    if (localStorage.getItem("permissions")) {
      const permissionsLS = localStorage.getItem("permissions");
      const permission = JSON.parse(permissionsLS);
      this.permissions = permission.filter(
        (e) => e.section == "ADMINS" && e.has_permission == true
      );
    }
    this.fetchAdmins();
  },
  methods: {
    async saveAdminPermission() {
      try {
        let dataMapped = [];
        this.sections.forEach((section) => {
          if (section.permissions) {
            let data = [];
            section.permissions.forEach((permission) => {
              data.push({
                section: section.name,
                permission_name: permission.name,
                has_permission: Boolean(permission.checked) ? 1 : 0,
                admin_user_id: this.add_permissions_for.id,
              });
            });
            dataMapped.push(...data);
          }
        });
        const data = await Promise.all(dataMapped);
        const payload = {
          type: "saveAdminPermissions",
          permissions: data,
        };
        const response = await axios({
          method: "POST",
          url: this.$root.URL_ROOT + "updatedApiForProducts.php",
          data: payload,
        });
        this.$toasted.global[response.data.status]({
          message: response.data.msg,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveAdmin() {
      try {
        const data = this.edit_id
          ? {
              type: "updateAdmins",
              edit_id: this.edit_id,
              ...this.user_details,
            }
          : {
              type: "createAdmins",
              ...this.user_details,
            };
        const response = await axios({
          method: "POST",
          url: this.$root.URL_ROOT + "updatedApiForProducts.php",
          data,
        });
        this.$toasted.global[response.data.status]({
          message: response.data.msg,
        });
        await this.fetchAdmins();
        this.CloseAddUser();
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAdmins() {
      try {
        const response = await axios({
          method: "POST",
          url: this.$root.URL_ROOT + "updatedApiForProducts.php",
          data: {
            type: "fetchAdmins",
          },
        });
        this.users = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteUser(user) {
      const params = {
        type: "deleteAdmins",
        edit_id: user.id,
      };
      const ev = this;
      this.$swal({
        title: "Delete this ?",
        text: "Are you sure? You won't be able to revert this!",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#f00",
        confirmButtonText: "Yes, Delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          axios({
            method: "POST",
            url: this.$root.URL_ROOT + "updatedApiForProducts.php",
            data: params,
          }).then(function (response) {
            ev.$toasted.global[response.data.status]({
              message: response.data.msg,
            });
            ev.fetchAdmins();
          });
        }
      });
    },
    editUser(user) {
      this.edit_id = user.id;
      this.user_details = {
        name: user.name,
        email: user.email,
        password: user.password,
      };
      this.add_user = true;
      this.add_permission = false;
    },
    async addPermissions(user) {
      this.add_permissions_for = user;
      await this.fetchPermissions();
      this.add_permission = true;
      this.add_user = false;
    },
    async fetchPermissions() {
      try {
        const response = await axios({
          method: "POST",
          url: this.$root.URL_ROOT + "updatedApiForProducts.php",
          data: {
            type: "fetchAdminPermissions",
            admin_id: this.add_permissions_for.id,
          },
        });
        this.sections.forEach((section) => {
          section.permissions.forEach((permission) => {
            // console.log(response.data.permissions.find(e => e.section == section.name && e.permission_name == permission.name ).has_permission);
            permission["checked"] = Boolean(
              response.data.permissions.find(
                (e) =>
                  e.section == section.name &&
                  e.permission_name == permission.name
              ).has_permission
            );
          });
          section.checked =
            section.permissions.filter((e) => e.checked == true).length ==
            section.permissions.length;
        });
      } catch (error) {
        console.log(error);
      }
    },
    closePermissions() {
      this.add_permission = false;
      this.add_user = false;
      this.add_permissions_for = null;
    },
    checkMain(section_index) {
      this.sections[section_index].permissions.forEach((element) => {
        element.checked = this.sections[section_index].checked;
      });
    },
    checkSub(section_index, permission_index) {
      if (
        this.sections[section_index].permissions[permission_index].checked ==
          false &&
        this.sections[section_index].checked == true
      ) {
        this.sections[section_index].checked = false;
      }
      if (
        this.sections[section_index].permissions[permission_index].checked ==
        true
      ) {
        this.sections[section_index].checked =
          this.sections[section_index].permissions.length ==
          this.sections[section_index].permissions.filter(
            (e) => e.checked == true
          ).length;
      }
    },
    OpenAddUser() {
      this.user_details = {
        name: null,
        email: null,
        password: null,
      };
      this.edit_id = null;
      this.add_user = true;
      this.add_permission = false;
    },
    CloseAddUser() {
      this.add_user = false;
      this.add_permission = false;
      this.user_details = {
        name: null,
        email: null,
        password: null,
      };
      this.edit_id = null;
    },
  },
};
</script>

<style>
</style>